function readEnv(key: string): string {
  try {
    const env = (import.meta.env || {}) as Record<string, unknown>
    const value = env[key]
    return value ? String(value) : ''
  } catch {
    return ''
  }
}

export function resolveApiUrl(url: string): string {
  const base = readEnv('VITE_API_URL')
  if (!base) return url

  const lower = String(url).toLowerCase()
  if (
    lower.startsWith('http://') ||
    lower.startsWith('https://') ||
    lower.startsWith('//')
  ) {
    return url
  }

  const baseClean = base.replace(/\/+$/, '')

  if (url.startsWith('/')) {
    if (baseClean.endsWith('/api') && url.startsWith('/api')) {
      return baseClean + url.slice('/api'.length)
    }
    return baseClean + url
  }

  return baseClean + '/' + url
}

type FetchJSONError = Error & { status?: number; data?: unknown }

export async function fetchJSON<T = Record<string, unknown>>(
  url: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(resolveApiUrl(url), init)

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    let data: unknown = null
    if (text) {
      try {
        data = JSON.parse(text)
      } catch {
        data = null
      }
    }
    const err = new Error(
      `HTTP ${res.status} ${res.statusText} on ${url}${text ? `: ${text}` : ''}`,
    ) as FetchJSONError
    err.status = res.status
    err.data = data
    throw err
  }

  return (await res.json()) as T
}
